import React, { useState, useContext } from 'react'
import ReactDOM from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ContentHeader } from '../../layout/Content'
import Searchbar from '../../layout/searchbar/Searchbar'
import ToolbarButton from '../../layout/ToolbarButton'
import StockOutController from '../stockout/StockOutController'
import StockOutListHeaderStyle from './css/StockOutListHeaderStyle'
import ModalWindow from '../../layout/modalwindow/ModalWindow'
import StockOutListSettingsForm from './StockOutListSettingsForm'
import { appContext } from '../../../App'
import { stockOutListControllerContext } from './StockOutListController'

function StockOutListToolbar(props) {
  const app = useContext(appContext)
  const searchInput = props.searchInput[0]
  const setContent = app.content[1]
  const stockOutListController = useContext(stockOutListControllerContext)
  const { reloadStockOutList, selectedSOId, batchDeleteSelectedSO } = stockOutListController

  const onClickSettings = () => {
    ReactDOM.render(
      <ModalWindow id='mw-parent' width='30' height='50' header='Settings' footer={null}>
        <StockOutListSettingsForm app={app} stockOutListController={stockOutListController}/>
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickTrash = (e) => {
    const showTrashMessageBox = () => {
      const onClick = (button) => {
        if (button === 'Yes') batchDeleteSelectedSO()
        ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      }

      ReactDOM.render (
        <ModalWindow
          id='mw-parent'
          header="Deleting StockOut's..."
          footer={null}>
            <div className='messagebox'>
              <div className='messagebox-content'>
                <div>Will delete all selected/checked StockOut records.</div>
                <br />
                <div>Do you want to continue?</div>
                <br />
              </div>
              <div className='button-container'>
                <button onClick={() => { onClick('No') }} className='pospro-action-btn top-anchor'>No</button>
                <button onClick={() => { onClick('Yes') }} className='pospro-action-btn bottom-anchor'>Yes</button>
              </div>
            </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }

    showTrashMessageBox()
  }

  return (
    <ToolbarButton>
      <button
        id='refresh-list'
        name='tb'
        disabled={searchInput}
        className={ searchInput ? 'pospro-action-btn toolbar-btn disabled-button' : 'pospro-action-btn toolbar-btn' }
        onClick={() => reloadStockOutList()}
        title='Refresh List'>
        <FontAwesomeIcon icon='sync-alt'/>
        <span className='tooltip-text'>Refresh list</span>
      </button>
      <button
        id='settings'
        name='tb'
        className='pospro-action-btn toolbar-btn'
        onClick={onClickSettings}
        title='Settings'>
        <FontAwesomeIcon icon='cog'/>
        <span className='tooltip-text'>Settings</span>
      </button>
      <button
        id='stock-out'
        name='tb'
        className='pospro-action-btn toolbar-btn'
        onClick={() => setContent(<StockOutController />)}
        title='Out stocks'>
        <FontAwesomeIcon icon='plus'/>
        <span className='tooltip-text'>Out Stocks</span>
      </button>
      <button
        id='batch-delete'
        name='tb'
        className={ selectedSOId.length ? 'pospro-action-btn toolbar-btn' : 'pospro-action-btn disabled-button' }
        disabled={!selectedSOId.length}
        onClick={onClickTrash}
        title='Batch delete'>
        <FontAwesomeIcon icon='trash'/>
        <span className='tooltip-text'>Batch Delete</span>
      </button>
    </ToolbarButton>
  )
}

function StockOutListHeader() {
  const app = useContext(appContext)
  const stockOutListController = useContext(stockOutListControllerContext)
  const { filterStockOutList } = stockOutListController
  const [searchStockOutList, setSearchStockOutList] = useState('')

  const searchbarProps = {
    search: searchStockOutList,
    setSearch: setSearchStockOutList,
    filter: filterStockOutList
  }

  return (
    <ContentHeader title='Stock-Out Transactions List'>
      <div id='stockout-list-toolbar'>
        <Searchbar { ...searchbarProps }/>
        <StockOutListToolbar searchInput={searchStockOutList}/>
      </div>
      <StockOutListHeaderStyle signed_in={app.client.signed_in}/>
    </ContentHeader>
  )
}

export default React.memo(StockOutListHeader)
